import partial from 'lodash.partial'

import { X_ACCESS_TOKEN_COOKIE_NAME } from '../constants'
import { getCookie } from '../utils'

const RP_API_KEY = process.env.REACT_APP_RP_API_KEY

const withApiKey = (url) => {
  if (RP_API_KEY) {
    url += (url.search(/\?/) === -1 ? '?' : '&') + `apikey=${RP_API_KEY}`
  }
  return url
}

const isType = (type, response) =>
  response.headers.get('content-type').search(new RegExp(`${type}`, 'i')) > -1
const isJson = partial(isType, 'json')
const isText = partial(isType, 'text')

const checkStatus = (response) =>
  new Promise((resolve, reject) => {
    if (response.ok) {
      resolve(response)
    } else {
      const error = new Error(response.statusText)
      error.statusCode = response.statusCode
      const extractor = isJson(response) ? 'json' : isText(response) ? 'text' : null
      if (extractor) {
        response[extractor]().then((body) => {
          error.response = body
          reject(error)
        })
      } else {
        reject(error)
      }
    }
  })

export const fetchWithTimeout = (url, init, timeout = 5000) => {
  return Promise.race([
    fetch(withApiKey(url), init).then(checkStatus),
    new Promise((resolve, reject) => {
      setTimeout(() => reject(`APPLICATION ENFORCED FETCH TIMEOUT ${timeout}: ${url}`), timeout)
    }),
  ])
}

// The api uses different keys based on the sorting attribute so we need to determine the key based on attribute. :(
export const getSortByKey = (sortBy) => 'sortBy' + sortBy.charAt(0).toUpperCase() + sortBy.slice(1)

export const withAuthHeaders = (headers = {}) => ({
  ...headers,
  'x-access-token': getCookie(X_ACCESS_TOKEN_COOKIE_NAME),
})
